import "@simplybusiness/theme-simplybusiness";
import { initialize, REACT_APP_SELECTOR } from "util/mountComponents";

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelectorAll(REACT_APP_SELECTOR).length === 0) {
    return;
  }

  // Lazy load the components so pages with no React aren't slowed down
  import("components/frontoffice")
    .then((Components) => {
      initialize(document, Components).then((elements) => {
        elements.forEach((x) => {
          if (typeof EventTracker !== "undefined") {
            EventTracker.attach(x);
          }
        });
      });
    })
    .catch((e) => {
      if (typeof newrelic !== "undefined") {
        newrelic.noticeError(e);
      }
    });
});
